import request from '@/utils/request'

export function findPublicApiV1Doc() {
  return request({
    url: `/doc/v1`,
    method: 'get'
  })
}
